module.exports = __webpack_public_path__ + "img/TradiNext-flag.31450b4f.png";